import axios from 'axios';
import * as Analytics from '@/Util/reporting.js';

export default async (commit, getters) => {
    let data;
    let payload = {
        userInfo: {
            firstName: getters.userInfo.firstName,
            lastName: getters.userInfo.lastName,
            email: getters.userInfo.email,
            phone: getters.userInfo.phone,
            ...(!!getters.userInfo.tenantId && {tenantId: getters.userInfo.tenantId})
        }
    };

    try {
        ({ data } = await axios.post(`/api/v1/message/contact-sales`, {
            ...payload
        }));

        Analytics.pushToDataLayer({
            event: 'form_submitted',
            attributes: {
                section: 'Contact sales monthly form',
                action: 'Submitted form',
            },
        });

        commit('setSubmittingContactSales', false);
        commit('contactedSales', true);
    } catch (error) {
        commit('setSubmittingContactSales', false);
        if (window.axios.isAxiosError(error)) {
            if (!!error.response) {
                const errorObj = error.response.data;
                window.Sentry.logError(error, {server_event_id: error.response.data.eventId});
                commit('setError', {
                    active: true,
                    code: errorObj.error,
                    message: errorObj.message
                });
            } else {
                window.Sentry.logError(error);
                commit('setError', {
                    active: true,
                    code: window.constants.errorCodes.generalError,
                    message: window.constants.errorMessages.generalError
                });
            }
        } else if (!getters.hasActiveError) {
            window.Sentry.logError(error);
            commit('setError', {
                active: true,
                code: window.constants.errorCodes.generalError
            });
        }
    }
}
